<script setup lang="ts">
import { ALBUM_LAYOUT_OPTIONS, type AlbumLayout } from '~/composables/useAlbumLayout'

defineProps<{
  modelValue: AlbumLayout
  disabled?: boolean
}>()

defineEmits<{
  'update:modelValue': [value: AlbumLayout]
}>()
</script>

<template>
  <div class="album-layout-switcher" role="group" aria-label="相册布局">
    <BlogUiTooltip v-for="option in ALBUM_LAYOUT_OPTIONS" :key="option.value" :content="option.label">
      <button
        type="button"
        class="album-layout-button"
        :class="{ active: modelValue === option.value }"
        :aria-pressed="modelValue === option.value"
        :aria-label="`${option.label}布局`"
        :data-layout="option.value"
        :disabled="disabled"
        @click="$emit('update:modelValue', option.value)"
      >
        <i :class="option.icon" aria-hidden="true" />
      </button>
    </BlogUiTooltip>
  </div>
</template>

<style scoped>
.album-layout-switcher {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px;
  border: 0;
  border-radius: 999px;
  background: var(--bg);
}

.album-layout-switcher :deep(.ui-tooltip-wrap) {
  display: inline-flex;
  overflow: visible;
}

.album-layout-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 30px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  color: var(--text-soft);
  font: inherit;
  line-height: 1;
  cursor: pointer;
  background: transparent;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.album-layout-button:hover:not(:disabled) {
  color: var(--text);
  background: var(--brand-soft);
}

.album-layout-button.active {
  color: var(--brand);
  background: var(--brand-soft);
}

.album-layout-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

html[data-album-list-layout] .albums-page .album-layout-button.active,
html[data-album-detail-layout] .album-detail-page .album-layout-button.active {
  color: var(--text-soft);
  background: transparent;
}

html[data-album-list-layout='relaxed'] .albums-page .album-layout-button[data-layout='relaxed'],
html[data-album-list-layout='immersive'] .albums-page .album-layout-button[data-layout='immersive'],
html[data-album-detail-layout='relaxed'] .album-detail-page .album-layout-button[data-layout='relaxed'],
html[data-album-detail-layout='immersive'] .album-detail-page .album-layout-button[data-layout='immersive'] {
  color: var(--brand);
  background: var(--brand-soft);
}

@media (max-width: 640px) {
  .album-layout-switcher {
    display: none;
  }
}

</style>
